module.exports = __webpack_public_path__ + "img/ico-radio-de.ae746f3e.svg";